export function getFilesFromDataTransfer(dt: DataTransfer) {
    if (dt.items) {
        return Array.from(dt.items)
            .filter(item => item.kind == 'file')
            .map(item => item.getAsFile() as File);
    } else {
        return Array.from(dt.files);
    }
}

export function getTextFromDataTransfer(dt: DataTransfer) {
    return new Promise<string>(resolve => {
        if (dt.items) {
            Array.from(dt.items)
                .filter(item => item.kind == 'string' && item.type == "text/plain")
                .slice(0, 1)
                .forEach(item => item.getAsString(resolve));
        } else {
            resolve(dt.getData('text'));
        }
    })
}